import { FormattedMainFile } from '../MainFiles';
import { EachPage } from './file-selected.interface';

export declare type CommonPagesI = EachPage[];

class CommonPages {
  commonPages: CommonPagesI;
  returnModel: boolean;
  constructor(commonPages: CommonPagesI, returnModel = false) {
    this.commonPages = commonPages;
    this.returnModel = returnModel;
  }

  static getCommonPagesFromSrcFilePageNum(
    srcFile: FormattedMainFile,
    pageNum?: number,
  ): CommonPagesI {
    return (pageNum === undefined
      ? srcFile.pages.map((p) => ({
          partId: srcFile.partId,
          pageNo: p.num,
        }))
      : [
          {
            partId: srcFile.partId,
            pageNo: pageNum,
          },
        ]
    ).map((p, i) => ({ ...p, fromGlobalCommonPage: i + 1 }));
  }

  static getEachCommonPage(
    partId: string,
    pageNo: number,
    fromGlobalCommonPage: number,
  ): EachPage {
    return {
      partId,
      pageNo,
      fromGlobalCommonPage,
    };
  }

  addPages(
    srcPartId: string,
    srcPageNums: number[],
  ): {
    result: CommonPagesI | CommonPages;
    fromGlobalCommonPage?: number;
  } {
    const fromGlobalCommonPage =
      this.commonPages.length === 0
        ? undefined
        : this.commonPages.length;
    const newCommonPages = this.commonPages
      .concat(
        srcPageNums.map((num) => ({
          partId: srcPartId,
          pageNo: num,
        })),
      )
      .map((p, i) => ({ ...p, fromGlobalCommonPage: i + 1 })); // reindex
    this.commonPages = newCommonPages;
    return {
      result: this.returnModel ? this : this.commonPages,
      fromGlobalCommonPage,
    };
  }

  addPage(
    srcPartId: string,
    srcPageNo: number,
  ): {
    result: CommonPagesI | CommonPages;
    fromGlobalCommonPage?: number;
  } {
    return this.addPageAfterPageIndex(srcPartId, srcPageNo);
  }
  //   TODO: implement functions here
  addPageAfterPageIndex(
    srcPartId: string,
    srcPageNo: number,
    pageIndex?, // where the page it should be after
  ): {
    result: CommonPagesI | CommonPages;
    fromGlobalCommonPage?: number;
  } {
    let fromGlobalCommonPage: undefined | number;
    if (srcPageNo < 1) throw Error(`pateNo must be >= 1`);
    let newPageItem: EachPage = {
      partId: srcPartId,
      pageNo: srcPageNo,
    };
    let newCommonPages: EachPage[];
    if (pageIndex === undefined) {
      fromGlobalCommonPage = this.commonPages.length;
      newCommonPages = this.commonPages.concat(newPageItem);
    } else if (pageIndex === -1) {
      newCommonPages = [newPageItem].concat(this.commonPages);
    } else {
      fromGlobalCommonPage = pageIndex + 1;
      newCommonPages = this.commonPages
        .slice(0, pageIndex + 1) // not sure if has to +1 page index or not
        .concat(newPageItem)
        .concat(this.commonPages.slice(pageIndex + 1));
    }
    // reindex
    this.commonPages = newCommonPages.map((p, i) => ({
      ...p,
      fromGlobalCommonPage: i + 1,
    }));
    return {
      result: this.returnModel ? this : this.commonPages,
      fromGlobalCommonPage,
    };
  }
  removePage(
    pageIndex: number,
  ): {
    result: CommonPages | CommonPagesI;
    fromGlobalPage: number;
  } {
    if (pageIndex > this.commonPages.length - 1) {
      throw Error(`invalid index`);
    }
    const fromGlobalPage = pageIndex + 1;

    this.commonPages = this.commonPages.filter(
      (p, i) => i !== pageIndex,
    ) as CommonPagesI;
    return {
      result: this.returnModel ? this : this.commonPages,
      fromGlobalPage,
    };
  }

  //   TODO: refactor this?
  movePage(
    oldPageIndex: number,
    insertAfterPageIndex: number,
  ): {
    result: CommonPages | CommonPagesI;
    fromFromGlobalPage: number;
    toFromGlobalPage: number;
  } {
    if (oldPageIndex > this.commonPages.length - 1)
      throw Error(`invalid index`);
    const oldItem = this.commonPages[oldPageIndex];
    const fromFromGlobalPage = oldItem.fromGlobalCommonPage as number;
    const incrToFromGlob =
      oldPageIndex > insertAfterPageIndex
        ? 2 // move left
        : 1; // move right
    const toFromGlobalPage = insertAfterPageIndex + incrToFromGlob;

    let newCommonPages = this.commonPages
      .slice(0, insertAfterPageIndex + 1)
      .concat(oldItem)
      .concat(this.commonPages.slice(insertAfterPageIndex + 1));
    console.debug(`movePage`, { oldPageIndex, insertAfterPageIndex });
    const toFilterOutIndex =
      oldPageIndex > insertAfterPageIndex
        ? oldPageIndex + 1 // move left
        : oldPageIndex; // move right

    newCommonPages = newCommonPages.filter(
      (p, i) => i !== toFilterOutIndex,
    );
    // reindex
    this.commonPages = newCommonPages.map((p, i) => ({
      ...p,
      fromGlobalCommonPage: i + 1,
    }));
    return {
      result: this.returnModel ? this : this.commonPages,
      fromFromGlobalPage,
      toFromGlobalPage,
    };
  }
}

export default CommonPages;
